/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespNullSearchResults_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
